import { render, staticRenderFns } from "./dr-designer-panel.vue?vue&type=template&id=9bc9bc9a&scoped=true"
import script from "./dr-designer-panel.vue?vue&type=script&lang=js"
export * from "./dr-designer-panel.vue?vue&type=script&lang=js"
import style0 from "./dr-designer-panel.vue?vue&type=style&index=0&id=9bc9bc9a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc9bc9a",
  null
  
)

export default component.exports